import { memo } from 'react';
import { AnimatePresence } from 'motion/react';
import { Stack } from 'src/components';
import * as S from './styles';

export type NumLives = 0 | 1 | 2 | 3;

interface LivesProps {
  numLives: NumLives;
  className?: string;
}

export const Heart = ({ lost }: { lost: boolean }) => {
  return (
    <>
      <AnimatePresence>{!lost && <S.FullHeart />}</AnimatePresence>
      {lost && <S.EmptyHeart />}
    </>
  );
};

const Lives = ({ numLives, className }: LivesProps) => (
  <Stack
    $direction="horizontal"
    $spacing="s1"
    data-testid="heartLivesLeftIndicator"
    className={className}
  >
    <S.HeartContainer>
      <Heart lost={numLives < 1} />
    </S.HeartContainer>
    <S.HeartContainer>
      <Heart lost={numLives < 2} />
    </S.HeartContainer>
    <S.HeartContainer>
      <Heart lost={numLives < 3} />
    </S.HeartContainer>
  </Stack>
);

export default memo(Lives);
